import { CompanyProfileSchema, CompanyProfileBaseSchema } from './CompanyProfile';

const ManufacturerSchema = CompanyProfileBaseSchema;

const ManufacturerProfileSchema = CompanyProfileSchema;

const ManufacturerPayloadSchema = ManufacturerSchema.extend({
    id: ManufacturerSchema.shape.id.optional(),
});

export { ManufacturerSchema, ManufacturerProfileSchema, ManufacturerPayloadSchema };
